import { Outlet } from "@tanstack/react-router";
import { SubNav } from "../../components/sub-nav";
import { useWorkspace } from "../../lib/workspace";

export function SettingsLayout() {
  const { project } = useWorkspace();
  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-5">
      <div>
        <h1 className="font-display text-xl font-semibold tracking-tight">Settings</h1>
        <p className="mt-1 text-sm text-fg-muted">Project configuration, keys and your personal access tokens.</p>
      </div>
      <SubNav
        label="Settings sections"
        projectId={project.id}
        items={[
          { to: "/p/$projectId/settings/project", label: "Project" },
          { to: "/p/$projectId/settings/tokens", label: "Personal tokens" },
        ]}
      />
      <Outlet />
    </div>
  );
}
